import * as Sentry from "@sentry/vue";
import {BrowserTracing} from "@sentry/tracing";

function registerSentry(router) {
    Sentry.init({
        Vue,
        dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
        ignoreErrors: [/.*jsAds.*/, /.*getBoundingClientRect.*/, /.*getElementById.*/, /.*solads.*/, /.*carousel.*/],
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                /**
                 * Note: adding hosts here can give more info but also ads extra headers to all requests including third parties that have these hosts in query params
                 * e.g. if you add 'erobella.com' Google Analytics going to be called with sentry header and blocked due CORS
                 */
                tracePropagationTargets: [],
            }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.0,
    });
}

export default registerSentry;
